import { StyleSheet } from 'react-native';
import { COLORS, FONTS } from '../../../../../constants';
import { STYLE_VARS } from '../../../../../constants/style-vars';

export const CheckoutTableStyles = StyleSheet.create({
  container: {
    paddingHorizontal: 15,
  },
  thead: {
    flexDirection: 'row',
    paddingVertical: 15,
    backgroundColor: STYLE_VARS.kccBgGreen,
    marginBottom: 20,
  },
  th_text: {
    fontSize: 12,
    fontFamily: FONTS.AvenirMedium,
    color: '#fff',
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  totalText: {
    fontFamily: FONTS.AvenirMedium,
    color: STYLE_VARS.primaryColor,
    fontWeight: '500',
    fontSize: 14,
    letterSpacing: 1,
  },
  titleText: {
    fontFamily: FONTS.AvenirLTStdBlack,
    textTransform: 'uppercase',
    color: COLORS.GREEN,
    fontWeight: '600',
    paddingHorizontal: 15,
    paddingVertical: 5,
    fontSize: 14,
  },
  contentDesktop: {
    fontSize: 14,
    fontFamily: FONTS.AvenirMedium,
    color: STYLE_VARS.primaryColor,
    textTransform: 'uppercase',
    fontWeight: '500',
    flex: 1,
  },
  checkoutContainer: {
    paddingHorizontal: 15,
  },
  countWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: 20,
  },
  count: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  countBtn: {
    width: 30,
    height: 30,
    borderWidth: 1,
    justifyContent: 'center',
    borderColor: COLORS.DARKER_GREY,
  },
  countBtnText: {
    color: COLORS.BLACK,
    textAlign: 'center',
    fontSize: 18,
  },
  countText: {
    fontSize: 14,
    paddingHorizontal: 20,
    color: COLORS.BLACK,
  },
  title: {
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    fontWeight: '500',
    fontSize: 16,
    letterSpacing: 1,
    marginBottom: 10,
    textTransform: 'uppercase',
  },
  content: {
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.DARKER_GREY,
    fontWeight: '500',
    fontSize: 13,
    letterSpacing: 1,
    textAlign: 'justify',
    marginBottom: 20,
  },
  productRecomentWrapper: {
    borderWidth: 0.5,
    borderColor: COLORS.DARKER_GREY,
    padding: 20,
    marginBottom: 30,
    flexDirection: 'column',
  },
  noteText: {
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    fontWeight: '500',
    fontSize: 12,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: 20,
    marginBottom: 200,
  },
  noDataText: {
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
  },
});
